/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationDetailsViewModel } from './locationDetailsViewModel';
import { ProviderDetailsViewModel } from './providerDetailsViewModel';

export interface ProviderLocationDetailsViewModel {
  id?: string;
  rowId?: number;
  datasetId?: string;
  providerId?: string;
  locationId?: string;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  locations?: Array<LocationDetailsViewModel> | null;
  providers?: Array<ProviderDetailsViewModel> | null;
}
